// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2574":"5a3c82f5","3147":"c2737b00","4431":"256ec4a7","9324":"493f6588"}[chunkId] + ".chunk.css";
};